
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CalculatorSize',
  data() {
    return {
      width: '',
      height: '',
      ratio: '',
    };
  },
  computed: {
    convertedRatio(): { rat1: number; rat2: number; } {
      const [aspectRatioDenominator, aspectRatioNumerator] = this.ratio.split(':');
      const rat1 = parseInt(aspectRatioDenominator, 10);
      const rat2 = parseInt(aspectRatioNumerator, 10);

      return {
        rat1,
        rat2,
      };
    },
  },
  methods: {
    calculateSize() {
      // TODO: validate input ratio
      if (!this.ratio || (!this.height && !this.width)) return;

      // TODO: what should i do if width and height is set?
      if ((this.width && !this.height) || (this.width && this.height)) {
        this.calculateHeight();
      }

      if (this.height && !this.width) {
        this.calculateWidth();
      }
    },
    calculateHeight() {
      // TODO: validate input width
      if (!this.ratio || !this.width) return;

      const { rat1, rat2 } = this.convertedRatio;
      const ratio = parseInt(this.width, 10) / rat1;
      const calculatedHeight = Math.round(ratio * rat2);
      this.height = `${calculatedHeight}`;
    },
    calculateWidth() {
      // TODO: validate input height
      if (!this.ratio || !this.height) return;

      const { rat1, rat2 } = this.convertedRatio;
      const calculatedWidth = Math.round(parseInt(this.height, 10) * (rat1 / rat2));
      this.width = `${calculatedWidth}`;
    },
    resetForm() {
      this.width = '';
      this.height = '';
      this.ratio = '';
    },
  },
});
